import React from 'react'
import classNames from 'classnames'

import styles from './PropertyList.module.css'

export default function PropertyList({ children, className }) {
  return <div className={classNames(styles.wrapper, className)}>{children}</div>
}
